import React, { useEffect, useState } from "react";
import interestedTagService from '../../Services/InterestedTagService'
import { showErrorToast } from "../../Constant/Notification";
const TagInput = ({ showToast  , handleInterestTags , disableInput }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 

  const [inputValue, setInputValue] = useState("");
  const [editingTag, setEditingTag] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(false); 
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await interestedTagService.fetchInterestedTag();
        if (response.status == 204) {
          setTags([]);
        } else {
          setTags(response.data);
          handleInterestTags(response?.data?.length)
        }
        console.log(response.data);
      } catch (err) {
        showErrorToast(err)

        setError("Error fetching tags");
      } finally {
        setLoading(false);
      }
    };

    fetchTags();
  }, [updateTrigger]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddTag = async () => {
    if (inputValue.trim() !== "") {
      if (editingTag !== null) {
        try {
          await interestedTagService.updateInterestedTag(editingTag.id, inputValue.trim())
          setEditingTag(null);

          showToast("Interest Tag updated successfully", "success");
        } catch (err) {
          
        showErrorToast(err.response.data)

        }
      } else {
        try {
          await interestedTagService.createInterestedTag(inputValue.trim());
          showToast("Interested Tag added successfully", "success");
        } catch (err) {

        showErrorToast(err.response.data)
        }
      }
      setInputValue(""); 
      setUpdateTrigger(!updateTrigger);
    }
  };

  const handleToggleEdit = (tag) => {
    setEditingTag(tag); 
    setInputValue(tag.name); 
  };

  return (
    <div className="flex container mx-auto p-5 pb-0 gap-16">
      <div className="custom-scrollbar overflow-x-hidden flex flex-wrap flex-auto w-7/12 h-64 rounded-md p-3 gap-x-2 gap-y-2  bg-appGrayBackground overflow-y-auto">
        {tags?.map((tag) => (
          <div
            key={tag.id}
            className="bg-customGreen h-8 rounded-lg px-3  text-sm font-normal text-white mr-2 mb-2 flex items-center"
          >
            {editingTag === tag ? (
              <>
                <button
                  className="ml-1 focus:outline-none"
                  onClick={handleAddTag}
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.08333 22.9167H5.10208L18.95 9.06875L16.9312 7.05L3.08333 20.8979V22.9167ZM0.25 25.75V19.7292L18.95 1.06458C19.2333 0.804861 19.5462 0.604167 19.8885 0.4625C20.2309 0.320833 20.591 0.25 20.9688 0.25C21.3465 0.25 21.7125 0.320833 22.0667 0.4625C22.4208 0.604167 22.7278 0.816667 22.9875 1.1L24.9354 3.08333C25.2188 3.34306 25.4253 3.65 25.5552 4.00417C25.6851 4.35833 25.75 4.7125 25.75 5.06667C25.75 5.44444 25.6851 5.80451 25.5552 6.14687C25.4253 6.48924 25.2188 6.80208 24.9354 7.08542L6.27083 25.75H0.25ZM17.9229 8.07708L16.9312 7.05L18.95 9.06875L17.9229 8.07708Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
              </>
            ) : (
              <>
                <span>{tag.name}</span>
                <button
                  className="ml-1 focus:outline-none"
                  onClick={() => handleToggleEdit(tag)}
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.08333 22.9167H5.10208L18.95 9.06875L16.9312 7.05L3.08333 20.8979V22.9167ZM0.25 25.75V19.7292L18.95 1.06458C19.2333 0.804861 19.5462 0.604167 19.8885 0.4625C20.2309 0.320833 20.591 0.25 20.9688 0.25C21.3465 0.25 21.7125 0.320833 22.0667 0.4625C22.4208 0.604167 22.7278 0.816667 22.9875 1.1L24.9354 3.08333C25.2188 3.34306 25.4253 3.65 25.5552 4.00417C25.6851 4.35833 25.75 4.7125 25.75 5.06667C25.75 5.44444 25.6851 5.80451 25.5552 6.14687C25.4253 6.48924 25.2188 6.80208 24.9354 7.08542L6.27083 25.75H0.25ZM17.9229 8.07708L16.9312 7.05L18.95 9.06875L17.9229 8.07708Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="flex flex-col w-5/12 relative mt-2">
        <div className="flex gap-5">
          <input
            type="text"
            placeholder=""
            value={inputValue}
            maxLength={50} 
            onChange={handleInputChange}
            className="px-3 py-1 h-10 w-96 text-sm rounded-md border  border-gray-300 focus:outline-none focus:border-blue-500"
          />
          <button
        className={`
          ${disableInput ?  'text-red-500 cursor-not-allowed' :'text-sky-500 cursor-pointer' }
          w-10 4xl:text-2xl 3xl:text-lg 2xl:text-lg custom-xl:text-lg xl:text-lg text-sm   rounded-md focus:outline-none
          `}     
          disabled={disableInput} 
        
            onClick={handleAddTag}
          >
            {editingTag !== null ? "Done" : "Add"}
          </button>
        </div>

        <p className="w-72 mt-5 4xl:text-2xl 3xl:text-lg">
          Note: Add location, property type, Payment Type other generic client
          interest info's
        </p>
      </div>
    </div>
  );
};

export default TagInput;
